<div
    class="threads"
    *ngIf="isInvited || isNoteOwner || (note.stream?.kind && note.stream?.kind < streamKind['InviteOnlyCommunity'] && isSubscribed)">
    <span class="reply-topic">Reply to thread: </span>
    <a [routerLink]="['/note', { parentId: note.id, parentStreamId: note.stream?.id,  k: (note.stream?.kind) ? note.stream?.kind : 0 }]"
       class="notd__button--v2 border--green"
       title="Reply to thread">{{parentNoteName || 'Reply to thread'}}</a>
</div>
